import { HawkSearchComponents, RecentSearchesFacetComponentConfig, RecentSearchesFacetComponentModel } from '@models';
import { searchService } from '@services';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './recent-searches-facet.component.hbs';

export class RecentSearchesFacetComponent extends BaseFacetComponent<RecentSearchesFacetComponentConfig, RecentSearchesFacetComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'recent-searches-facet';
    protected override defaultHtml = defaultHtml;

    protected override renderContent(): boolean {
        return !!this.data?.values?.length;
    }

    protected override getContentModel(): RecentSearchesFacetComponentModel {
        return {
            values: this.data!.values?.map((v) => v.title) ?? []
        };
    }

    protected bindChildElements(): void {
        super.bindChildElements();

        this.rootElement.querySelectorAll('[hawksearch-query]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLElement;
                const query = element.getAttribute('hawksearch-query');

                if (query) {
                    searchService.query(query);
                }
            });
        });
    }
}
